import Link from '@mui/material/Link';

import { LogoWhite } from '@src/components/icons';


function LogoSection() {
  return (
    <Link to="/" >
      <LogoWhite sx={StyleSheet.logo} />
    </Link>
  );
};

const StyleSheet = {
  logo: { width: '100%', height: '100%' },
};

LogoSection.displayName = 'LogoSection';
export default LogoSection;
